import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResourcesService } from '../services/resources.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-add-resource-question',
  templateUrl: './add-resource-question.component.html',
  styleUrls: ['./add-resource-question.component.css']
})
export class AddResourceQuestionComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public _dialogRef: MatDialogRef<AddResourceQuestionComponent>, public _resourcesService: ResourcesService, public log: LogService) { }

  public resourcesArray = [];
  public title = "";
  public question = "";
  public resource_id = "";
  public constr;


  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Add Resource Question",
      details: `Accessed Add Resource Question`,
    }).subscribe(data => { });
    let obj = {course_id: this.data.course_id}
    this._resourcesService.getAllResources(obj).subscribe(data => {
      this.resourcesArray = data;
    })
  }

  getResourceId(event) {
    this.resource_id = event.value;
  }

  addQuestion() {
    if (this.resource_id == "none") {
      let resource_id = this.resourcesArray[0].resource_id;
      // type - question type (0)->not-general question (1)-general question
      let obj = {title: this.title, question: this.question, resource_id: resource_id, type: 1};
      this._resourcesService.addResourcesQuestion(obj).subscribe(data => {
        let res = {...data, type: "general"};
        this._dialogRef.close(res)
      })
    } else {
      let resourceObj = this.resourcesArray.find((each) => each.resource_id == this.resource_id);
      let obj = {title: this.title, question: this.question, resource_id: this.resource_id, type: 0};
      this._resourcesService.addResourcesQuestion(obj).subscribe(data => {
        let res = {...data, type: "not-general", resource: resourceObj.resource};
        this._dialogRef.close(res)
      })
    }

  }

}
